<template lang="pug">
    th.dt-checkbox
        label.md-check
            input(
                type="checkbox",
                @change="toogleAllRowSelected()",
                v-model="checkAll"
            )
            i.indigo
</template>

<script>
import mixins from '../mixins';

export default {
    mixins: [mixins],

    data() {
        return {
            checkAll: false,
        };
    },

    watch: {
        isAllRowSelected() {
            this.checkAll = this.isAllRowSelected;
        },
    },

    methods: {
        toogleAllRowSelected() {
            const payload = {
                uniqueKeys: this.uniqueKeys,
                insert: this.checkAll,
            };

            this.$store.dispatch(
                `${this.namespaced}/toogleAllRowSelected`,
                payload,
            );
        },
    },
};
</script>
